export default __webpack_public_path__ + "static/media/home-interior-design-portfolio-img04.9eb67033.jpg";